import { UUID } from 'node:crypto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { UserService } from './user.service';

export interface IScanningPrefixPostRequest extends IBaseScannerPrefix {
	// No additional properties
}

export interface IScanningPrefixPutRequest extends IBaseScannerPrefix {
	// No additional properties
}

export interface IBaseScannerPrefix {
	prefix: string;
}

export interface IScanningPrefix extends IBaseScannerPrefix {
	id: UUID;
}

export interface IScanningPrefixResponse {
	result: IScanningPrefix[];
}

@Injectable({
	providedIn: 'root',
})
export class ScanningPrefixService {
	constructor(
		private http: HttpClient,
		private userService: UserService,
	) {}

	create(scanningPrefix: IScanningPrefix): Observable<IScanningPrefix> {
		const request: IScanningPrefixPostRequest = {
			prefix: scanningPrefix.prefix,
		};

		return this.http.post<IScanningPrefix>(this.getUrl(), request, {
			headers: this.userService.getHeaders(),
		});
	}

	update(scanningPrefix: IScanningPrefix): Observable<IScanningPrefix> {
		const request: IScanningPrefixPutRequest = {
			prefix: scanningPrefix.prefix,
		};

		return this.http.put<IScanningPrefix>(this.getUrl(scanningPrefix.id), request, {
			headers: this.userService.getHeaders(),
		});
	}

	getAll(): Observable<IScanningPrefix[]> {
		return this.http.get<IScanningPrefixResponse>(this.getUrl(), { headers: this.userService.getHeaders() }).pipe(map((response) => response.result));
	}

	delete(id: string): Observable<any> {
		return this.http.delete(this.getUrl(id), {
			headers: this.userService.getHeaders(),
		});
	}

	getUrl(id?: string | null) {
		return `${environment.awsEnvUri}/mes/scanningprefixes${id ? `/${id}` : ''}`;
	}
}
